import React from 'react';
import PropTypes from 'prop-types';
import InputMaterial from '../../../../front-v2/components/uiElements/forms/InputMaterial';
import TextField from 'material-ui/TextField';

const TextPicker = ({
    id,
    params: { type, placeholder = 'Edit text', active = false, ...params } = {},
    fullWidth = true,
    updateWidgetJSPropField,
    isCustomInput = true,
}) => {
    if (id == null || type !== 'string' || Object.keys(params || {}).length === 0 || !active) {
        return null;
    }

    const InputComponent = isCustomInput ? InputMaterial : TextField;

    return (
        <div>
            {Object.entries((params && params.propsMap) || {}).map(([key]) => (
                <InputComponent
                    key={key}
                    fullWidth={fullWidth}
                    floatingLabelText={placeholder}
                    value={params[key]}
                    onChange={(event, value) => {
                        updateWidgetJSPropField(id, { [key]: value });
                    }}
                />
            ))}
        </div>
    );
};

TextPicker.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    params: PropTypes.shape({
        text: PropTypes.string,
        placeholder: PropTypes.string,
    }),
    fullWidth: PropTypes.bool,
    isCustomInput: PropTypes.bool,
    updateWidgetJSPropField: PropTypes.func.isRequired,
};

export default TextPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/TextPicker.js
 **/